import { useMutation, useQuery } from "react-query";
import {
  createSubscriptionPlanConsumption,
  getPlans,
  getSubscriptionPlanConsumption,
} from "./requests";

export const useCreateSubscriptionPlanConsumption = () =>
  useMutation(createSubscriptionPlanConsumption);
export const useGetAllPlans = (entity: string, isEnabled: boolean) =>
  useQuery(["allPlans", entity], () => getPlans(entity), {
    enabled: isEnabled,
    refetchInterval: 30000,
  });
export const useGetSubscriptionPlanConsumption = () =>
  useQuery(["subscriptionPlanConsumption "], () =>
    getSubscriptionPlanConsumption());
